module.exports = __webpack_public_path__ + "static/media/Example of Timelogs.6767b56b.csv";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Example of Timelogs.csv
// module id = 771
// module chunks = 0